import React from 'react';
import { Box, Button, FormControl, InputLabel, MenuItem, Select, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DashaCycles } from '../../hooks/useDashaCycles';
import { formatDashaDate } from '../../utils/dashaCalculator';

export default function DashaCycleSelector({ cycles, onCurrent }: { cycles: DashaCycles; onCurrent?: () => void }) {
  const { t } = useTranslation();
  const labelId = React.useId();
  const { timeline, setCycle, currentCycle, showCycleSelector } = cycles;
  if (!showCycleSelector || !timeline) return null;
  const { cycleNumber, cycleStart, cycleEnd, timezoneMinutes } = timeline;
  const count = Math.max(5, currentCycle + 1, cycleNumber + 1);
  return <Box sx={{ my: 2 }}>
    <Stack direction="row" flexWrap="wrap" alignItems="center" gap={1}>
      <Button aria-label="Previous dasha cycle" disabled={cycleNumber === 1} onClick={() => setCycle(cycleNumber - 1)}>‹</Button>
      <FormControl size="small" sx={{ minWidth: 160 }}>
        <InputLabel id={labelId}>{t('dashaCycles.label', { defaultValue: 'Dasha cycle' })}</InputLabel>
        <Select labelId={labelId} value={cycleNumber} label={t('dashaCycles.label', { defaultValue: 'Dasha cycle' })} onChange={event => setCycle(Number(event.target.value))}>
          {Array.from({ length: count }, (_, i) => i + 1).map(cycle => <MenuItem key={cycle} value={cycle}>{t('dashaCycles.cycle', { defaultValue: 'Cycle {{number}}', number: cycle })}</MenuItem>)}
        </Select>
      </FormControl>
      <Button aria-label="Next dasha cycle" onClick={() => setCycle(cycleNumber + 1)}>›</Button>
      <Button onClick={() => { setCycle(currentCycle); onCurrent?.(); }}>{t('common.current', { defaultValue: 'Current' })}</Button>
    </Stack>
    <Typography variant="caption" color="text.secondary">{formatDashaDate(cycleStart, timezoneMinutes)} – {formatDashaDate(cycleEnd, timezoneMinutes)} · {t('dashaCycles.duration', { defaultValue: '120 years per cycle' })}</Typography>
  </Box>;
}
